import { Component, Input } from '@angular/core';

@Component({
  selector: 'wz-page',
  templateUrl: './tunnelsante-page.component.html',
  styleUrls: ['./tunnelsante-page.component.scss'],
  standalone: false,
})
export class TunnelSantePageComponent {
  @Input() backLink!: string;
  @Input() title!: string;
  @Input() wzTitle!: string;
}
